import { Record } from 'immutable';
import { Party } from './party';
import { RatePlanCode } from './rate-plan-code';

const EventRecord = Record({
  eventId: null,
  version: null,
  createdDate: null,
  modifiedDate: null,
  name: null,
  eventAgency: new Party(),
  eventClient: new Party(),
  eventProperty: new Party(),
  brand: null,
  chain: null,
  propertyId: null,
  agencyId: null,
  clientReferenceNumber: null,
  startDate: null,
  endDate: null,
  attritionGuaranteePercentage: null,
  attritionMinRoomNights: null,
  commissionRoomPercentage: null,
  attritionCutoffDate: null,
  roomRateCutoffDate: null,
  depositAmount: null,
  totalFoodBeverageRevenue: null,
  inactive: null,
  autoGenerated: false,
  autoPayment: null,
  canBeDeleted: false,
  canManageReservations: false,
  currency: null,
  ratePlanCodes: [],
  masterBillPaid: false,
  commRetention: false,
  shoulderDatesCommission: false
});

export class OnyxEvent extends EventRecord {
  eventId: number;
  version: number;
  createdDate: Date;
  modifiedDate: Date;
  name: string;
  eventAgency: Party;
  eventClient: Party;
  eventProperty: Party;
  brand: string;
  chain: string;
  propertyId: string;
  agencyId: string;
  clientReferenceNumber: string;
  startDate: string;
  endDate: string;
  attritionGuaranteePercentage: string;
  attritionMinRoomNights: string;
  commissionRoomPercentage: number;
  attritionCutoffDate: string;
  roomRateCutoffDate: string;
  depositAmount: string;
  totalFoodBeverageRevenue: string;
  inactive: string;
  autoGenerated: boolean;
  autoPayment: boolean;
  canBeDeleted: boolean;
  canManageReservations: boolean;
  groupCodeNumber: string;
  currency: string;
  ratePlanCodes: RatePlanCode[];
  masterBillPaid: boolean;
  commRetention: boolean;
  shoulderDatesCommission: boolean;
  public isAgencyControlled(): boolean {
    return !this.eventProperty.subscriber;
  }

  public isPropertyControlled(): boolean {
    return this.eventProperty.subscriber;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event.ts